import { Parser } from 'expr-eval';
function evaluate(formula, scope) {
    const parser = new Parser();
    let expr = parser.parse(formula);
    return expr.evaluate(scope);
}
export default evaluate;
